// src/api/api.js
import axios from "axios";
import { devApiUrl, prodApiUrl } from '@/config';
import Cookies from "js-cookie";
import { Message } from 'element-ui';

// 判断当前环境
const isDev = process.env.NODE_ENV === 'development';
// 创建axios实例并配置基础地址
const apiClient = axios.create({
    baseURL: isDev ? devApiUrl : prodApiUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 请求拦截器 - 自动添加token
apiClient.interceptors.request.use(
    config => {
        // 获取token
        const token = localStorage.getItem('loginToken') || Cookies.get('loginToken');

        // 如果有token，添加到请求头
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        config._hadAuthToken = Boolean(token);

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器 - 处理错误
apiClient.interceptors.response.use(
    response => {
        // 检查业务层面的错误码
        if (response.data && response.data.code === 401 && response.config._hadAuthToken) {
            Message.error('身份认证过期，请重新登录');

            // 清除认证信息
            Cookies.remove("loginToken");
            localStorage.removeItem("userAvatar");
            localStorage.removeItem("loginToken");

            // 延迟跳转，确保提示信息能显示
            setTimeout(() => {
                window.location.href = '/';
            }, 1500);
        }
        return response;
    },
);

// 封装通用请求方法
export const getRequest = (url, params) => {
    return apiClient.get(url, { params });
}

export const postRequest = (url, data) => {
    return apiClient.post(url, data);
}

// 导出实例备用
export default apiClient;
